export function bannerWithParallax() {
    const $window = $(window);
    let $bannerSection = $(".banner-with-parallax");
    let bannerImage;
    let bannerContent;
    $bannerSection.eq($bannerSection.length - 1).addClass("last-child");

    function bannerAnimation() {
        let winTop = $window.scrollTop();
        $bannerSection.each(function () {
            let $this = $(this);
            let sectionTop = $this.offset().top;
            let sectionHeight = $this.innerHeight();
            let parallaxCoef = (winTop - sectionTop) * 0.065;
            bannerImage = $this.find(".photo-holder");
            bannerContent = $this.find(".content-holder");
            if (winTop > sectionTop) {
                $this.addClass("show");
            } else {
                $this.removeClass("show");
            }
            if (winTop > sectionTop + (sectionHeight / 4)) {
                $this.addClass("rendered-photo");
            } else {
                $this.removeClass("rendered-photo");
            }
            if (winTop > sectionTop && winTop < sectionTop + $window.innerHeight() * 2) {
                bannerImage.css({
                    "transform": "translateY(" + parallaxCoef + "px)"
                });
                if ($window.innerWidth() >= 1024) {
                    bannerContent.css({
                        "transform": "translateY(-" + parallaxCoef + "px)"
                    });
                } else {
                    bannerContent.css({
                        "transform": "translateY(0)"
                    });
                }
            }
        });
    }

    $window.on("load scroll", function () {
        bannerAnimation();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bannerWithParallax.js